import { useState } from 'react'

import xor from 'lodash/xor'

type Return = [
  number[],
  (newValue: number | null | undefined) => void,
  (newValues: number[]) => void
]

const useSelectIds = (initialArray: number[] = []): Return => {
  const [values, setValues] = useState(initialArray)

  const setSelectedValue = (newValue: number | null | undefined) => {
    if (!newValue) {
      setValues([])

      return
    }

    setValues(xor(values, [newValue]))
  }

  const setSelectedValues = (newValues: number[]) => {
    setValues(newValues)
  }

  return [values, setSelectedValue, setSelectedValues]
}

export default useSelectIds
